import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  emitIframeMessage,
  IframeMessage,
} from '@longnecktech/splash-commons-fe';
import {
  DeeplinkingProvider,
  YeetBetType,
} from '@shared/constants/deeplinking.consts';
import { DeepLinkingBet, DeepLinkingResponse } from '@shared/types/deeplinking';
import { navigateTopSafely } from '@shared/utils/navigate-top-safely.util';

export function handleDeeplinkingResponse(
  res: DeepLinkingResponse | null | undefined,
  bets: DeepLinkingBet[],
  sanitizer: DomSanitizer,
): void {
  if (!res) return;

  if (res.code) {
    emitIframeMessage(IframeMessage.Deeplinking, { code: res.code });
  }

  if (res.redirectUrl) {
    const link = sanitizer.sanitize(SecurityContext.URL, res.redirectUrl);
    if (link) {
      navigateTopSafely(link);
    }
  }

  if (res.altenarOddsPayload?.oddIds) {
    emitIframeMessage(IframeMessage.Deeplinking, {
      oddIds: res.altenarOddsPayload.oddIds,
      type: 'splash_add_selection',
    });
  }

  if (res.altenarEventsPayload?.eventId) {
    emitIframeMessage(IframeMessage.Deeplinking, {
      eventId: res.altenarEventsPayload.eventId,
      type: 'splash_redirect_to_event',
    });
  }

  handleProviderSpecificEmit(res.provider, bets);
}

function handleProviderSpecificEmit(
  provider: DeeplinkingProvider | undefined,
  bets: DeepLinkingBet[],
): void {
  switch (provider) {
    case DeeplinkingProvider.NoviBet:
      emitIframeMessage(IframeMessage.AddToBetslip, {
        betslipItems: bets.map((bet) => ({
          betContextId: String(bet.EventId),
          marketInstanceId: String(bet.BetData),
          betInstanceId: String(bet.ExternalOddsId),
        })),
      });
      return;

    case DeeplinkingProvider.Yeet:
      emitYeetBetslip(bets);
      return;

    case undefined:
      return;

    default: {
      const _exhaustive: never = provider;
      return _exhaustive;
    }
  }
}

function emitYeetBetslip(bets: DeepLinkingBet[]): void {
  if (bets.length === 0) return;

  const firstEventId = bets[0].EventId;
  const allSameEvent = bets.every((b) => b.EventId === firstEventId);

  // Multiple bets on the same event
  if (bets.length > 1 && allSameEvent) {
    emitIframeMessage(IframeMessage.AddToBetslip, {
      type: YeetBetType.BetBuilder,
      eventId: Number(firstEventId),
      selections: bets.map((bet) => ({
        eventMarketId: bet.BetData,
        eventMarketOutcomeId: bet.ExternalOddsId,
      })),
    });
    return;
  }

  // Single bet or multiple bets across different events
  emitIframeMessage(IframeMessage.AddToBetslip, {
    type: YeetBetType.Regular,
    selections: bets.map((bet) => ({
      eventId: Number(bet.EventId),
      eventMarketId: bet.BetData,
      eventMarketOutcomeId: bet.ExternalOddsId,
    })),
  });
}
